var webooker_schedule_models = webooker_schedule_models || {};

(function (ns) {

    ns.UserScheduleDetailAttendance = function (userScheduleDetailAttendanceDto, userScheduleDetail) {

        this.dto = userScheduleDetailAttendanceDto;
        this.userScheduleDetail = userScheduleDetail;

        this.studentID = userScheduleDetailAttendanceDto.studentID;
        this.fullName = userScheduleDetailAttendanceDto.fullName;
        this.courseAttendanceTypeID = userScheduleDetailAttendanceDto.courseAttendanceTypeID;
        this.present = userScheduleDetailAttendanceDto.present;
        this.noOfAvailableAmends = userScheduleDetailAttendanceDto.noOfAvailableAmends;
        this.preAmendsCount = userScheduleDetailAttendanceDto.preAmendsCount;
        this.timeBoundAmendCount = userScheduleDetailAttendanceDto.timeBoundAmendCount;
        this.waitQueueReservationsCount = userScheduleDetailAttendanceDto.waitQueueReservationsCount;
        this.causalPrice = userScheduleDetailAttendanceDto.causalPrice;

        // Calculated

        this.effectiveCourseAttendanceTypeID = this.present
            ? this.courseAttendanceTypeID
            : this.noOfAvailableAmends > 0
                ? 2 // amend
                : (this.preAmendsCount - this.noOfAvailableAmends + this.timeBoundAmendCount) > 0
                    ? 2 // amend
                    : 1; // oneOff

        this.oneOffDisabled = this.effectiveCourseAttendanceTypeID === 1 && this.causalPrice == null;
        this.showPrice = this.effectiveCourseAttendanceTypeID === 1 && !!this.causalPrice &&
                         (this.userScheduleDetail.attendanceChangesAllowed || this.present);

        this.presentReadOnly =
            !this.userScheduleDetail.attendanceChangesAllowed ||
            (this.oneOffDisabled && this.effectiveCourseAttendanceTypeID === 1 && !this.present  /* OneOff */);
    }

    Object.defineProperty(ns.UserScheduleDetailAttendance.prototype, 'actualPreAmendsCount', {
        enumerable: true, configurable: true,
        get: function () {

            if (this.effectiveCourseAttendanceTypeID === 2 && (this.present !== this.dto.present)) {
                if (this.present && !this.dto.present) {
                    if (this.waitQueueIndex > 0) {
                        return this.noOfAvailableAmends <= 0
                            ? Math.max(0, this.preAmendsCount + this.noOfAvailableAmends + this.timeBoundAmendCount)
                            : this.preAmendsCount + this.timeBoundAmendCount;
                    } else {
                        return this.noOfAvailableAmends <= 0
                            ? Math.max(0, this.preAmendsCount + this.noOfAvailableAmends + this.timeBoundAmendCount - 1)
                            : this.preAmendsCount + this.timeBoundAmendCount - 1;
                    }
                }

                if (!this.present && this.dto.present) {
                    if (this.noOfAvailableAmends < 0) {
                        if (this.userScheduleDetail.attendanceChangesInTime) {
                            var virtualWaitQueueIndex = this.userScheduleDetail.getVirtualWaitQueueIndex.call(this.userScheduleDetail, this, true, true);
                            if (virtualWaitQueueIndex > 0) {
                                return Math.max(0, this.preAmendsCount + this.noOfAvailableAmends + this.timeBoundAmendCount);
                            } else {
                                return Math.max(0, this.preAmendsCount + this.noOfAvailableAmends + this.timeBoundAmendCount + 1);
                            }
                        } else {
                            return Math.max(0, this.preAmendsCount + this.noOfAvailableAmends + this.timeBoundAmendCount);
                        }
                    } else {
                        return this.preAmendsCount + this.timeBoundAmendCount;
                    }
                }

            } else {
                return this.noOfAvailableAmends < 0
                    ? Math.max(0, this.preAmendsCount + this.noOfAvailableAmends + this.timeBoundAmendCount)
                    : this.preAmendsCount + this.timeBoundAmendCount;
            }
        }
    });

    Object.defineProperty(ns.UserScheduleDetailAttendance.prototype, 'actualAmendsCount', {
        enumerable: true, configurable: true,
        get: function () {
            if ((this.effectiveCourseAttendanceTypeID === 2 || this.effectiveCourseAttendanceTypeID === 0) && (this.present !== this.dto.present)) {
                if (this.present && !this.dto.present) {
                    if (this.waitQueueIndex > 0) {
                        return this.noOfAvailableAmends;
                    } else {
                        if ((this.preAmendsCount + this.timeBoundAmendCount) > 0) {
                            return Math.max(this.noOfAvailableAmends, 0);
                        }
                        else {
                            return Math.max(this.noOfAvailableAmends - 1, 0);
                        }
                    }
                }

                if (!this.present && this.dto.present) {
                    if (this.noOfAvailableAmends < 0 || !this.userScheduleDetail.attendanceChangesInTime) {
                        return Math.max(this.noOfAvailableAmends, 0);
                    } else {
                        var studentID = this.studentID;
                        var waitQueuePresent = _.find(this.userScheduleDetail.waitQueue, function (w) { return w.studentID === studentID });
                        if (waitQueuePresent) {
                            return this.noOfAvailableAmends;
                        } else {
                            return Math.max(this.noOfAvailableAmends + 1, 0);
                        }
                    }
                }

            } else {
                return Math.max(this.noOfAvailableAmends, 0);
            }
        }
    });

    Object.defineProperty(ns.UserScheduleDetailAttendance.prototype, 'waitQueueIndex', {
        enumerable: true, configurable: true,
        get: function () {
            return this.userScheduleDetail.getVirtualWaitQueueIndex.call(this.userScheduleDetail, this, this.present, this.dto.present);
        }
    });

})(webooker_schedule_models);